function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { memo, useEffect } from 'react';
import { useFormFieldWithSelector } from 'formydable';
import classNames from 'classnames';
import Form from 'react-bootstrap/Form';
import { useFormManager } from './FormCore';
const Boolean = /*#__PURE__*/memo(({
  label,
  rules,
  name,
  checked,
  className,
  formGroupClassName,
  description,
  required,
  ...props
}) => {
  const {
    readonly
  } = useFormManager();
  const {
    fieldState,
    formRegistry,
    setFieldValue
  } = useFormFieldWithSelector(name);
  const state = fieldState;
  useEffect(() => {
    return formRegistry({
      label: typeof label === 'string' ? label : name,
      value: checked,
      rules,
      name
    }); // eslint-disable-next-line
  }, [checked]);

  const handleChange = e => {
    setFieldValue(name, e.target.checked);
  };

  return /*#__PURE__*/React.createElement(Form.Group, {
    className: formGroupClassName
  }, /*#__PURE__*/React.createElement(Form.Check, _extends({
    custom: true,
    id: name
  }, props, {
    disabled: readonly || props.disabled,
    checked: state.value,
    className: classNames(className, {
      'is-invalid': state.isInvalid
    }),
    isInvalid: state.isInvalid,
    label: label,
    onChange: handleChange
  })), /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    className: "mt-4",
    type: "invalid"
  }, state.message), !state.isInvalid && description && /*#__PURE__*/React.createElement(Form.Text, {
    className: "text-muted mt-4"
  }, description));
});
Boolean.defaultProps = {
  checked: false
};
export default Boolean;